import { useCallback, useState } from 'react';
import { useVariable } from './useVariable';
export const useInOut = (onIn, onOut, initialState = false) => {
  const [isIn, setIn] = useState(initialState);
  const onInHandler = useVariable(onIn);
  const onOutHandler = useVariable(onOut);
  const handleOut = useCallback(e => {
    onOutHandler.current?.(e);
    setIn(false);
  }, []);
  const handleIn = useCallback(e => {
    onInHandler.current?.(e);
    setIn(true);
  }, []);
  return [isIn, handleIn, handleOut];
};